import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';
import { useFetchData } from '../hooks/use-fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Json: { input: any; output: any; }
  NonEmptyString: { input: string; output: string; }
  Upload: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type Brand = {
  __typename?: 'Brand';
  accept_contract?: Maybe<Scalars['Boolean']['output']>;
  account_number?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['Json']['output']>;
  admin?: Maybe<Scalars['Boolean']['output']>;
  api?: Maybe<Scalars['String']['output']>;
  api_token?: Maybe<Scalars['String']['output']>;
  bank_address?: Maybe<Scalars['Json']['output']>;
  beneficiary_name?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_ops_email?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  delivery_services?: Maybe<Scalars['Json']['output']>;
  has_mixed_delivery_delay?: Maybe<Scalars['Boolean']['output']>;
  has_pre_order_delivery?: Maybe<Scalars['Boolean']['output']>;
  has_shipping_service?: Maybe<Scalars['Boolean']['output']>;
  has_shopify?: Maybe<Scalars['Boolean']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  intracommunity_vat?: Maybe<Scalars['String']['output']>;
  isReseller?: Maybe<Scalars['Boolean']['output']>;
  is_autoentrepreneur?: Maybe<Scalars['Boolean']['output']>;
  max_delivery_delay?: Maybe<Scalars['Int']['output']>;
  min_delivery_delay?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  need_refresh_info: Scalars['Boolean']['output'];
  plugins?: Maybe<Plugins>;
  return_address?: Maybe<Scalars['Json']['output']>;
  routing_code?: Maybe<Scalars['String']['output']>;
  sales?: Maybe<Array<Maybe<Sale>>>;
  serverTime?: Maybe<Scalars['DateTime']['output']>;
  shipping_country?: Maybe<Scalars['String']['output']>;
  shipping_services?: Maybe<Scalars['Json']['output']>;
  shopify?: Maybe<ShopifyData>;
  shopify_url?: Maybe<Scalars['String']['output']>;
  siret?: Maybe<Scalars['String']['output']>;
  store: StoreRegion;
  swift_code?: Maybe<Scalars['String']['output']>;
  tax_id?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export enum BrandRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** **Billing statistics for a sale by day** */
export type HistogramElement = {
  __typename?: 'HistogramElement';
  /**
   * **Date of stats**
   * - > *format* : YYYY-MM-DD
   */
  date: Scalars['String']['output'];
  nb_distinct_orders?: Maybe<Scalars['Int']['output']>;
  total_billing_ht?: Maybe<Scalars['Int']['output']>;
  total_billing_ttc?: Maybe<Scalars['Int']['output']>;
  total_commission_ht?: Maybe<Scalars['Int']['output']>;
  total_commission_ttc?: Maybe<Scalars['Int']['output']>;
  total_operation_ht?: Maybe<Scalars['Int']['output']>;
  total_operation_ttc?: Maybe<Scalars['Int']['output']>;
  total_vat?: Maybe<Scalars['Int']['output']>;
};

/** **Invoice created** */
export type InvoiceCreated = {
  __typename?: 'InvoiceCreated';
  id: Scalars['ID']['output'];
};

/** **Invoice updated** */
export type InvoiceUpdated = {
  __typename?: 'InvoiceUpdated';
  id: Scalars['ID']['output'];
};

export enum LogisticProvider {
  Bigblue = 'BIGBLUE',
  Sendcloud = 'SENDCLOUD'
}

export type Mutation = {
  __typename?: 'Mutation';
  confirmCsv?: Maybe<Scalars['String']['output']>;
  removeCsv?: Maybe<Scalars['String']['output']>;
  resyncShopifyOrders: Scalars['Int']['output'];
  resyncShopifyStock: Scalars['Boolean']['output'];
  setInfoAsUpToDate?: Maybe<Scalars['String']['output']>;
  setupShopifyCredentials?: Maybe<ShopifyData>;
  /** **Submit brand interest for the reviews feature** */
  submitReviewsFeatureInterest?: Maybe<Scalars['Void']['output']>;
  translateClaim: TranslateResponse;
  updateSeller?: Maybe<Scalars['String']['output']>;
  updateShopifyInfo?: Maybe<UpdatedShopifyData>;
  updateWidget?: Maybe<Scalars['String']['output']>;
  uploadCsvFile?: Maybe<Scalars['String']['output']>;
};


export type MutationConfirmCsvArgs = {
  saleId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationRemoveCsvArgs = {
  saleId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationResyncShopifyOrdersArgs = {
  saleId: Scalars['String']['input'];
};


export type MutationResyncShopifyStockArgs = {
  saleId: Scalars['String']['input'];
};


export type MutationSetupShopifyCredentialsArgs = {
  brandId: Scalars['String']['input'];
  data: ShopifyCredentialsInput;
};


export type MutationSubmitReviewsFeatureInterestArgs = {
  isInterested: Scalars['Boolean']['input'];
};


export type MutationTranslateClaimArgs = {
  claimId: Scalars['ID']['input'];
  to: Scalars['String']['input'];
};


export type MutationUpdateSellerArgs = {
  updateSeller: UpdateSeller;
};


export type MutationUpdateShopifyInfoArgs = {
  data: UpdateShopifyInfoInput;
};


export type MutationUpdateWidgetArgs = {
  data: UpdateWidget;
  id: Scalars['String']['input'];
};


export type MutationUploadCsvFileArgs = {
  saleId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** **Order created** */
export type OrderCreated = {
  __typename?: 'OrderCreated';
  id: Scalars['ID']['output'];
};

/** **Order updated** */
export type OrderUpdated = {
  __typename?: 'OrderUpdated';
  id: Scalars['ID']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
};

export type Plugins = {
  __typename?: 'Plugins';
  shopify?: Maybe<Scalars['Json']['output']>;
};

export type Query = {
  __typename?: 'Query';
  brand?: Maybe<Brand>;
  /** @deprecated Use getUploadUrl2 instead */
  getUploadUrl?: Maybe<Scalars['Json']['output']>;
  getUploadUrl2?: Maybe<UploadReturn>;
  ratings?: Maybe<Rates>;
  returns: Returns;
  /** **Get statistics for a sale per days ** */
  statsHistogram: Array<HistogramElement>;
  /** **Get statistics for a sale** */
  statsV2: StatsV2;
  topProductsStats: TopProductsStats;
  /** **Verify shopify identification ** */
  verifyShopifyCredentials: VerifyShopifyCredentialsOutput;
};


export type QueryGetUploadUrlArgs = {
  upload: Scalars['Upload']['input'];
};


export type QueryGetUploadUrl2Args = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};


export type QueryRatingsArgs = {
  filter?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyWithMessage?: InputMaybe<Scalars['Boolean']['input']>;
  saleId: Scalars['String']['input'];
};


export type QueryReturnsArgs = {
  saleId: Scalars['String']['input'];
};


export type QueryStatsHistogramArgs = {
  saleId: Scalars['NonEmptyString']['input'];
};


export type QueryStatsV2Args = {
  saleId: Scalars['NonEmptyString']['input'];
};


export type QueryTopProductsStatsArgs = {
  optionKey?: InputMaybe<Scalars['String']['input']>;
  saleId: Scalars['String']['input'];
};


export type QueryVerifyShopifyCredentialsArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

/** **Count of rates given by rates values** */
export type RateCountAggByRate = {
  __typename?: 'RateCountAggByRate';
  /** **Count of rates given for this rate value** */
  count: Scalars['Int']['output'];
  /** **Rate value** */
  rate: Scalars['Int']['output'];
};

export type Rates = {
  __typename?: 'Rates';
  nodes: Array<Rating>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Rating = {
  __typename?: 'Rating';
  avatar?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  rate?: Maybe<Scalars['Int']['output']>;
  rate_message?: Maybe<Scalars['String']['output']>;
  rate_updated_at?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ReturnProduct = {
  __typename?: 'ReturnProduct';
  description: Scalars['String']['output'];
  image: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sum: Scalars['Int']['output'];
};

export type ReturnStat = {
  __typename?: 'ReturnStat';
  code: Scalars['String']['output'];
  subCode?: Maybe<ReturnSubReason>;
  sum: Scalars['Int']['output'];
};

export enum ReturnSubReason {
  SizeDoesNotFit = 'SIZE_DOES_NOT_FIT',
  SizeOther = 'SIZE_OTHER',
  SizeSeveralSizesOrdered = 'SIZE_SEVERAL_SIZES_ORDERED',
  SizeTooLong = 'SIZE_TOO_LONG',
  SizeTooShort = 'SIZE_TOO_SHORT',
  SizeTooTight = 'SIZE_TOO_TIGHT',
  SizeTooWide = 'SIZE_TOO_WIDE'
}

export type Returns = {
  __typename?: 'Returns';
  percentage?: Maybe<Scalars['Float']['output']>;
  products?: Maybe<Array<Maybe<ReturnProduct>>>;
  returns?: Maybe<Array<Maybe<ReturnStat>>>;
  total_orders?: Maybe<Scalars['Int']['output']>;
  total_sum?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Sale = {
  __typename?: 'Sale';
  brand_id: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  currency: StoreCurrency;
  description?: Maybe<Scalars['String']['output']>;
  end_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  is_selection?: Maybe<Scalars['Boolean']['output']>;
  logistics_manager?: Maybe<Scalars['String']['output']>;
  preview_link: Scalars['String']['output'];
  selection_name?: Maybe<Scalars['String']['output']>;
  setup_email: Scalars['String']['output'];
  setup_ready: Scalars['Boolean']['output'];
  start_at?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SaleStatus>;
  store: StoreRegion;
  widgets?: Maybe<Array<Maybe<Widget>>>;
};

export enum SaleStatus {
  Ended = 'ENDED',
  Ongoing = 'ONGOING',
  /** @deprecated Use setup_ready instead */
  Ready = 'READY',
  Upcoming = 'UPCOMING'
}

export type ShopifyCredentialsInput = {
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  internationalCarrierCode?: InputMaybe<Scalars['String']['input']>;
  /** **Set the price of an order while sending data to shopify (either 0 or the real price)** */
  isProductPriceKept: Scalars['Boolean']['input'];
  isStockLive: Scalars['Boolean']['input'];
  logisticProvider?: InputMaybe<LogisticProvider>;
  mondialRelayCarrierCode?: InputMaybe<Scalars['String']['input']>;
  sharedSecret: Scalars['String']['input'];
  shop: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ShopifyData = {
  __typename?: 'ShopifyData';
  canReadLocations: Scalars['Boolean']['output'];
  canSyncReturn: Scalars['Boolean']['output'];
  canWriteThirdPartyFulfillmentOrders: Scalars['Boolean']['output'];
  carrierCode?: Maybe<Scalars['String']['output']>;
  enableReturnOrderCreation: Scalars['Boolean']['output'];
  internationalCarrierCode?: Maybe<Scalars['String']['output']>;
  inventoryNames?: Maybe<Array<Scalars['String']['output']>>;
  isProductPriceKept: Scalars['Boolean']['output'];
  isStockLive: Scalars['Boolean']['output'];
  lastStockSyncAt?: Maybe<Scalars['DateTime']['output']>;
  lastStockSyncCount?: Maybe<Scalars['Int']['output']>;
  logisticProvider?: Maybe<LogisticProvider>;
  mondialRelayCarrierCode?: Maybe<Scalars['String']['output']>;
  orderTag?: Maybe<Scalars['String']['output']>;
  sharedSecret?: Maybe<Scalars['String']['output']>;
  shop: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

/** **Statistics for a sale** */
export type StatsV2 = {
  __typename?: 'StatsV2';
  /** **Brand is subject to VAT ?** */
  isSubjectToVat: Scalars['Boolean']['output'];
  /**
   * **Count of orders**
   *
   * - > not removed
   * - > not from another order
   * - > older than 10min ago
   */
  orderCount: Scalars['Int']['output'];
  /**
   * **Count of products sold**
   *
   * - > from orders not removed
   * - > from orders not from another order
   * - > from orders older than 10min ago
   */
  productSoldCount: Scalars['Int']['output'];
  /**
   * **Average of rates given** (can be `null` if there is no rate)
   *
   * - > from orders not removed
   * - > from orders not from another order
   * - > from orders older than 10min ago
   */
  rateAvg?: Maybe<Scalars['Float']['output']>;
  /**
   * **Count of rates given**
   *
   * - > from orders not removed
   * - > from orders not from another order
   * - > from orders older than 10min ago
   */
  rateCount: Scalars['Int']['output'];
  /**
   * **Count of rates given by rates values**
   *
   * - > from orders not removed
   * - > from orders not from another order
   * - > from orders older than 10min ago
   */
  rateCountAggByRates: Array<RateCountAggByRate>;
  /**
   * **Amount due to the brand (without VAT)**
   *
   * - > *including* : shipping fees
   * - > *excluding* : commissions, refunds, returns
   */
  totalBillingHt: Scalars['Int']['output'];
  /**
   * **Amount due to the brand (include VAT)**
   *
   * - > *including* : shipping fees
   * - > *excluding* : commissions, refunds, returns
   */
  totalBillingTtc: Scalars['Int']['output'];
  /**
   * **Amount turnover (without VAT)**
   *
   * - > *including* : shipping fees, commissions
   * - > *excluding* : refunds, returns
   */
  totalTurnoverHt: Scalars['Int']['output'];
  /**
   * **Amount turnover (include VAT)**
   *
   * - > *including* : shipping fees, commissions
   * - > *excluding* : refunds, returns
   */
  totalTurnoverTtc: Scalars['Int']['output'];
};

export enum StoreCurrency {
  Eur = 'eur',
  Usd = 'usd'
}

export enum StoreRegion {
  Fr = 'fr',
  Us = 'us'
}

/** **Subscription** */
export type Subscription = {
  __typename?: 'Subscription';
  /** **Invoice created** */
  invoiceCreated: InvoiceCreated;
  /** **Invoice updated** */
  invoiceUpdated: InvoiceUpdated;
  /** **Order created** */
  orderCreated: OrderCreated;
  /** **Order updated** */
  orderUpdated: OrderUpdated;
  /** **Widget updated** */
  widgetUpdated?: Maybe<Widget>;
};

export type TopProductInfo = {
  __typename?: 'TopProductInfo';
  group_id: Scalars['String']['output'];
  image_url: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  product_id: Scalars['String']['output'];
  product_name: Scalars['String']['output'];
  purchased_count: Scalars['Int']['output'];
  total_amount: Scalars['Int']['output'];
  variants: Array<TopProductVariantInfo>;
};

export type TopProductVariantInfo = {
  __typename?: 'TopProductVariantInfo';
  image_url: Scalars['String']['output'];
  option_value?: Maybe<Scalars['String']['output']>;
  options: Array<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  product_id: Scalars['String']['output'];
  product_name: Scalars['String']['output'];
  purchased_count: Scalars['Int']['output'];
  total_amount: Scalars['Int']['output'];
  variant_id: Scalars['String']['output'];
};

export type TopProductsStats = {
  __typename?: 'TopProductsStats';
  available_option_keys: Array<Scalars['String']['output']>;
  current_option_key?: Maybe<Scalars['String']['output']>;
  products: Array<Maybe<TopProductInfo>>;
};

export type TranslateResponse = {
  __typename?: 'TranslateResponse';
  originalLanguage?: Maybe<Scalars['String']['output']>;
  translation: Scalars['String']['output'];
};

export type UpdateSeller = {
  accept_contract?: InputMaybe<Scalars['Boolean']['input']>;
  account_number?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['Json']['input']>;
  bank_address?: InputMaybe<Scalars['Json']['input']>;
  beneficiary_name?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_ops_email?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  delivery_services?: InputMaybe<Scalars['Json']['input']>;
  has_mixed_delivery_delay?: InputMaybe<Scalars['Boolean']['input']>;
  has_pre_order_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  has_shopify?: InputMaybe<Scalars['Boolean']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  intracommunity_vat?: InputMaybe<Scalars['String']['input']>;
  is_autoentrepreneur?: InputMaybe<Scalars['Boolean']['input']>;
  max_delivery_delay?: InputMaybe<Scalars['Int']['input']>;
  min_delivery_delay?: InputMaybe<Scalars['Int']['input']>;
  return_address?: InputMaybe<Scalars['Json']['input']>;
  routing_code?: InputMaybe<Scalars['String']['input']>;
  shipping_country?: InputMaybe<Scalars['String']['input']>;
  shipping_services?: InputMaybe<Scalars['Json']['input']>;
  shopify_url?: InputMaybe<Scalars['String']['input']>;
  siret?: InputMaybe<Scalars['String']['input']>;
  swift_code?: InputMaybe<Scalars['String']['input']>;
  tax_id?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  used_couriers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateShopifyInfoInput = {
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  internationalCarrierCode?: InputMaybe<Scalars['String']['input']>;
  /** **Set the price of an order while sending data to shopify (either 0 or the real price)** */
  isProductPriceKept: Scalars['Boolean']['input'];
  isStockLive: Scalars['Boolean']['input'];
  logisticProvider?: InputMaybe<LogisticProvider>;
  mondialRelayCarrierCode?: InputMaybe<Scalars['String']['input']>;
  sharedSecret?: InputMaybe<Scalars['String']['input']>;
  /** ** Connection information */
  shop?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWidget = {
  results?: InputMaybe<Scalars['Json']['input']>;
  state: WidgetState;
};

export type UpdatedShopifyData = {
  __typename?: 'UpdatedShopifyData';
  canReadLocations: Scalars['Boolean']['output'];
  canSyncReturn: Scalars['Boolean']['output'];
  canWriteThirdPartyFulfillmentOrders: Scalars['Boolean']['output'];
  carrierCode?: Maybe<Scalars['String']['output']>;
  enableReturnOrderCreation: Scalars['Boolean']['output'];
  internationalCarrierCode?: Maybe<Scalars['String']['output']>;
  inventoryNames?: Maybe<Array<Scalars['String']['output']>>;
  isProductPriceKept: Scalars['Boolean']['output'];
  isStockLive: Scalars['Boolean']['output'];
  logisticProvider?: Maybe<LogisticProvider>;
  mondialRelayCarrierCode?: Maybe<Scalars['String']['output']>;
  orderTag?: Maybe<Scalars['String']['output']>;
};

export type UploadReturn = {
  __typename?: 'UploadReturn';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum VerifyShopifyCredentialsError {
  MissingScope = 'MISSING_SCOPE',
  NotFound = 'NOT_FOUND',
  Unauthorized = 'UNAUTHORIZED',
  UnknownError = 'UNKNOWN_ERROR'
}

export type VerifyShopifyCredentialsOutput = {
  __typename?: 'VerifyShopifyCredentialsOutput';
  /** **Error message** */
  error?: Maybe<VerifyShopifyCredentialsError>;
  /** **Tells if the access token is correct for url provided** */
  isValidAccessToken: Scalars['Boolean']['output'];
  /** **Tells if the URL is a valid shopify url** */
  isValidUrl: Scalars['Boolean']['output'];
};

export type Widget = {
  __typename?: 'Widget';
  brand_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  proposition?: Maybe<Scalars['Json']['output']>;
  results?: Maybe<Scalars['Json']['output']>;
  state?: Maybe<WidgetState>;
  type?: Maybe<WidgetType>;
};

export enum WidgetState {
  Accepted = 'ACCEPTED',
  Refused = 'REFUSED'
}

export enum WidgetType {
  Duration = 'DURATION',
  Stock = 'STOCK'
}

export type WidgetFieldsFragment = { __typename?: 'Widget', id: string, type?: WidgetType | null, state?: WidgetState | null, results?: any | null, proposition?: any | null };

export type BrandQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', accept_contract?: boolean | null, account_number?: string | null, address?: any | null, bank_address?: any | null, beneficiary_name?: string | null, contact_email?: string | null, contact_ops_email?: string | null, contact_name?: string | null, contact_phone?: string | null, has_mixed_delivery_delay?: boolean | null, has_pre_order_delivery?: boolean | null, has_shopify?: boolean | null, iban?: string | null, id: string, is_autoentrepreneur?: boolean | null, intracommunity_vat?: string | null, max_delivery_delay?: number | null, min_delivery_delay?: number | null, name?: string | null, need_refresh_info: boolean, return_address?: any | null, routing_code?: string | null, serverTime?: string | null, shipping_country?: string | null, shopify_url?: string | null, siret?: string | null, store: StoreRegion, swift_code?: string | null, tax_id?: string | null, timezone?: string | null, plugins?: { __typename?: 'Plugins', shopify?: any | null } | null, sales?: Array<{ __typename?: 'Sale', id: string, start_at?: string | null, end_at?: string | null, logistics_manager?: string | null, selection_name?: string | null, store: StoreRegion, currency: StoreCurrency, preview_link: string, setup_email: string, setup_ready: boolean, status?: SaleStatus | null, widgets?: Array<{ __typename?: 'Widget', id: string, type?: WidgetType | null, state?: WidgetState | null, results?: any | null, proposition?: any | null } | null> | null } | null> | null, shopify?: { __typename?: 'ShopifyData', canReadLocations: boolean, canSyncReturn: boolean, canWriteThirdPartyFulfillmentOrders: boolean, carrierCode?: string | null, enableReturnOrderCreation: boolean, internationalCarrierCode?: string | null, inventoryNames?: Array<string> | null, isProductPriceKept: boolean, isStockLive: boolean, lastStockSyncAt?: string | null, logisticProvider?: LogisticProvider | null, mondialRelayCarrierCode?: string | null, orderTag?: string | null, sharedSecret?: string | null, shop: string, token?: string | null } | null } | null };

export type ApiKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeyQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', api_token?: string | null } | null };

export type StatsHistogramQueryVariables = Exact<{
  saleId: Scalars['NonEmptyString']['input'];
}>;


export type StatsHistogramQuery = { __typename?: 'Query', statsHistogram: Array<{ __typename?: 'HistogramElement', date: string, nb_distinct_orders?: number | null, total_operation_ht?: number | null, total_operation_ttc?: number | null }> };

export type RatingsQueryVariables = Exact<{
  saleId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyWithMessage?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RatingsQuery = { __typename?: 'Query', ratings?: { __typename?: 'Rates', totalCount?: number | null, totalPages?: number | null, updatedAt?: string | null, nodes: Array<{ __typename?: 'Rating', avatar?: string | null, name?: string | null, order_id?: string | null, products?: Array<any | null> | null, rate?: number | null, rate_message?: string | null, rate_updated_at?: string | null, url?: string | null }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage?: boolean | null } | null } | null };

export type TopProductsStatsQueryVariables = Exact<{
  saleId: Scalars['String']['input'];
  optionKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type TopProductsStatsQuery = { __typename?: 'Query', topProductsStats: { __typename?: 'TopProductsStats', available_option_keys: Array<string>, current_option_key?: string | null, products: Array<{ __typename?: 'TopProductInfo', group_id: string, image_url: string, options: Array<string>, product_name: string, product_id: string, purchased_count: number, total_amount: number, variants: Array<{ __typename?: 'TopProductVariantInfo', image_url: string, option_value?: string | null, options: Array<string>, price: number, product_id: string, product_name: string, purchased_count: number, total_amount: number, variant_id: string }> } | null> } };

export type StatsQueryVariables = Exact<{
  saleId: Scalars['NonEmptyString']['input'];
}>;


export type StatsQuery = { __typename?: 'Query', statsV2: { __typename?: 'StatsV2', isSubjectToVat: boolean, orderCount: number, productSoldCount: number, rateAvg?: number | null, rateCount: number, totalBillingHt: number, totalBillingTtc: number, totalTurnoverHt: number, totalTurnoverTtc: number, rateCountAggByRates: Array<{ __typename?: 'RateCountAggByRate', rate: number, count: number }> } };

export type ReturnsQueryVariables = Exact<{
  saleId: Scalars['String']['input'];
}>;


export type ReturnsQuery = { __typename?: 'Query', returns: { __typename?: 'Returns', percentage?: number | null, total_orders?: number | null, total_sum?: number | null, updatedAt?: string | null, products?: Array<{ __typename?: 'ReturnProduct', description: string, image: string, options?: Array<string | null> | null, sum: number } | null> | null, returns?: Array<{ __typename?: 'ReturnStat', sum: number, code: string, subCode?: ReturnSubReason | null } | null> | null } };

export type UploadUrlQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
}>;


export type UploadUrlQuery = { __typename?: 'Query', getUploadUrl2?: { __typename?: 'UploadReturn', url: string, key: string } | null };

export type VerifyShopifyCredentialsQueryVariables = Exact<{
  url: Scalars['String']['input'];
  accessToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifyShopifyCredentialsQuery = { __typename?: 'Query', verifyShopifyCredentials: { __typename?: 'VerifyShopifyCredentialsOutput', isValidAccessToken: boolean, isValidUrl: boolean, error?: VerifyShopifyCredentialsError | null } };

export type RemoveCsvMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type RemoveCsvMutation = { __typename?: 'Mutation', removeCsv?: string | null };

export type ConfirmCsvMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type ConfirmCsvMutation = { __typename?: 'Mutation', confirmCsv?: string | null };

export type UploadCsvFileMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type UploadCsvFileMutation = { __typename?: 'Mutation', uploadCsvFile?: string | null };

export type UpdateWidgetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateWidget;
}>;


export type UpdateWidgetMutation = { __typename?: 'Mutation', updateWidget?: string | null };

export type UpdateSellerMutationVariables = Exact<{
  updateSeller: UpdateSeller;
}>;


export type UpdateSellerMutation = { __typename?: 'Mutation', updateSeller?: string | null };

export type SetInfoAsUpToDateMutationVariables = Exact<{ [key: string]: never; }>;


export type SetInfoAsUpToDateMutation = { __typename?: 'Mutation', setInfoAsUpToDate?: string | null };

export type TranslateClaimMutationVariables = Exact<{
  claimId: Scalars['ID']['input'];
  to: Scalars['String']['input'];
}>;


export type TranslateClaimMutation = { __typename?: 'Mutation', translateClaim: { __typename?: 'TranslateResponse', originalLanguage?: string | null, translation: string } };

export type ResyncShopifyOrdersMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
}>;


export type ResyncShopifyOrdersMutation = { __typename?: 'Mutation', resyncShopifyOrders: number };

export type ResyncShopifyStockMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
}>;


export type ResyncShopifyStockMutation = { __typename?: 'Mutation', resyncShopifyStock: boolean };

export type SetupShopifyCredentialsMutationVariables = Exact<{
  brandId: Scalars['String']['input'];
  data: ShopifyCredentialsInput;
}>;


export type SetupShopifyCredentialsMutation = { __typename?: 'Mutation', setupShopifyCredentials?: { __typename?: 'ShopifyData', carrierCode?: string | null, internationalCarrierCode?: string | null, isProductPriceKept: boolean, isStockLive: boolean, mondialRelayCarrierCode?: string | null, logisticProvider?: LogisticProvider | null, sharedSecret?: string | null, shop: string, token?: string | null, canSyncReturn: boolean, enableReturnOrderCreation: boolean, orderTag?: string | null, inventoryNames?: Array<string> | null, canReadLocations: boolean, canWriteThirdPartyFulfillmentOrders: boolean } | null };

export type SubmitReviewsFeatureInterestMutationVariables = Exact<{
  isInterested: Scalars['Boolean']['input'];
}>;


export type SubmitReviewsFeatureInterestMutation = { __typename?: 'Mutation', submitReviewsFeatureInterest?: any | null };

export type UpdateShopifyInfoMutationVariables = Exact<{
  data: UpdateShopifyInfoInput;
}>;


export type UpdateShopifyInfoMutation = { __typename?: 'Mutation', updateShopifyInfo?: { __typename?: 'UpdatedShopifyData', carrierCode?: string | null, internationalCarrierCode?: string | null, isProductPriceKept: boolean, isStockLive: boolean, mondialRelayCarrierCode?: string | null, logisticProvider?: LogisticProvider | null, canSyncReturn: boolean, enableReturnOrderCreation: boolean, orderTag?: string | null, inventoryNames?: Array<string> | null, canReadLocations: boolean, canWriteThirdPartyFulfillmentOrders: boolean } | null };

export type InvoiceCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type InvoiceCreatedSubscription = { __typename?: 'Subscription', invoiceCreated: { __typename?: 'InvoiceCreated', id: string } };

export type InvoiceUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type InvoiceUpdatedSubscription = { __typename?: 'Subscription', invoiceUpdated: { __typename?: 'InvoiceUpdated', id: string } };

export type OrderCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OrderCreatedSubscription = { __typename?: 'Subscription', orderCreated: { __typename?: 'OrderCreated', id: string } };

export type OrderUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OrderUpdatedSubscription = { __typename?: 'Subscription', orderUpdated: { __typename?: 'OrderUpdated', id: string } };

export type WidgetUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type WidgetUpdatedSubscription = { __typename?: 'Subscription', widgetUpdated?: { __typename?: 'Widget', id: string, type?: WidgetType | null, state?: WidgetState | null, results?: any | null, proposition?: any | null } | null };


export const WidgetFieldsFragmentDoc = `
    fragment WidgetFields on Widget {
  id
  type
  state
  results
  proposition
}
    `;
export const BrandDocument = `
    query brand {
  brand {
    accept_contract
    account_number
    address
    bank_address
    beneficiary_name
    contact_email
    contact_ops_email
    contact_name
    contact_phone
    has_mixed_delivery_delay
    has_pre_order_delivery
    has_shopify
    iban
    id
    is_autoentrepreneur
    intracommunity_vat
    max_delivery_delay
    min_delivery_delay
    name
    need_refresh_info
    plugins {
      shopify
    }
    return_address
    routing_code
    sales {
      id
      start_at
      end_at
      logistics_manager
      selection_name
      widgets {
        ...WidgetFields
      }
      store
      currency
      preview_link
      setup_email
      setup_ready
      status
    }
    serverTime
    shipping_country
    shopify {
      canReadLocations
      canSyncReturn
      canWriteThirdPartyFulfillmentOrders
      carrierCode
      enableReturnOrderCreation
      internationalCarrierCode
      inventoryNames
      isProductPriceKept
      isStockLive
      lastStockSyncAt
      logisticProvider
      mondialRelayCarrierCode
      orderTag
      sharedSecret
      shop
      token
    }
    shopify_url
    siret
    store
    swift_code
    tax_id
    timezone
  }
}
    ${WidgetFieldsFragmentDoc}`;

export const useBrandQuery = <
      TData = BrandQuery,
      TError = unknown
    >(
      variables?: BrandQueryVariables,
      options?: Omit<UseQueryOptions<BrandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brand'] : ['brand', variables],
    queryFn: useFetchData<BrandQuery, BrandQueryVariables>(BrandDocument).bind(null, variables),
    ...options
  }
    )};

useBrandQuery.getKey = (variables?: BrandQueryVariables) => variables === undefined ? ['brand'] : ['brand', variables];

export const useInfiniteBrandQuery = <
      TData = InfiniteData<BrandQuery>,
      TError = unknown
    >(
      variables: BrandQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BrandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BrandQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<BrandQuery, BrandQueryVariables>(BrandDocument)
    return useInfiniteQuery<BrandQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['brand.infinite'] : ['brand.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteBrandQuery.getKey = (variables?: BrandQueryVariables) => variables === undefined ? ['brand.infinite'] : ['brand.infinite', variables];

export const ApiKeyDocument = `
    query apiKey {
  brand {
    api_token
  }
}
    `;

export const useApiKeyQuery = <
      TData = ApiKeyQuery,
      TError = unknown
    >(
      variables?: ApiKeyQueryVariables,
      options?: Omit<UseQueryOptions<ApiKeyQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiKeyQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiKeyQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['apiKey'] : ['apiKey', variables],
    queryFn: useFetchData<ApiKeyQuery, ApiKeyQueryVariables>(ApiKeyDocument).bind(null, variables),
    ...options
  }
    )};

useApiKeyQuery.getKey = (variables?: ApiKeyQueryVariables) => variables === undefined ? ['apiKey'] : ['apiKey', variables];

export const useInfiniteApiKeyQuery = <
      TData = InfiniteData<ApiKeyQuery>,
      TError = unknown
    >(
      variables: ApiKeyQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ApiKeyQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiKeyQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ApiKeyQuery, ApiKeyQueryVariables>(ApiKeyDocument)
    return useInfiniteQuery<ApiKeyQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['apiKey.infinite'] : ['apiKey.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteApiKeyQuery.getKey = (variables?: ApiKeyQueryVariables) => variables === undefined ? ['apiKey.infinite'] : ['apiKey.infinite', variables];

export const StatsHistogramDocument = `
    query statsHistogram($saleId: NonEmptyString!) {
  statsHistogram(saleId: $saleId) {
    date
    nb_distinct_orders
    total_operation_ht
    total_operation_ttc
  }
}
    `;

export const useStatsHistogramQuery = <
      TData = StatsHistogramQuery,
      TError = unknown
    >(
      variables: StatsHistogramQueryVariables,
      options?: Omit<UseQueryOptions<StatsHistogramQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StatsHistogramQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<StatsHistogramQuery, TError, TData>(
      {
    queryKey: ['statsHistogram', variables],
    queryFn: useFetchData<StatsHistogramQuery, StatsHistogramQueryVariables>(StatsHistogramDocument).bind(null, variables),
    ...options
  }
    )};

useStatsHistogramQuery.getKey = (variables: StatsHistogramQueryVariables) => ['statsHistogram', variables];

export const useInfiniteStatsHistogramQuery = <
      TData = InfiniteData<StatsHistogramQuery>,
      TError = unknown
    >(
      variables: StatsHistogramQueryVariables,
      options: Omit<UseInfiniteQueryOptions<StatsHistogramQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<StatsHistogramQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<StatsHistogramQuery, StatsHistogramQueryVariables>(StatsHistogramDocument)
    return useInfiniteQuery<StatsHistogramQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['statsHistogram.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteStatsHistogramQuery.getKey = (variables: StatsHistogramQueryVariables) => ['statsHistogram.infinite', variables];

export const RatingsDocument = `
    query ratings($saleId: String!, $offset: Int, $onlyWithMessage: Boolean, $filter: Int) {
  ratings(
    saleId: $saleId
    offset: $offset
    onlyWithMessage: $onlyWithMessage
    filter: $filter
  ) {
    nodes {
      avatar
      name
      order_id
      products
      rate
      rate_message
      rate_updated_at
      url
    }
    pageInfo {
      hasNextPage
    }
    totalCount
    totalPages
    updatedAt
  }
}
    `;

export const useRatingsQuery = <
      TData = RatingsQuery,
      TError = unknown
    >(
      variables: RatingsQueryVariables,
      options?: Omit<UseQueryOptions<RatingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RatingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RatingsQuery, TError, TData>(
      {
    queryKey: ['ratings', variables],
    queryFn: useFetchData<RatingsQuery, RatingsQueryVariables>(RatingsDocument).bind(null, variables),
    ...options
  }
    )};

useRatingsQuery.getKey = (variables: RatingsQueryVariables) => ['ratings', variables];

export const useInfiniteRatingsQuery = <
      TData = InfiniteData<RatingsQuery>,
      TError = unknown
    >(
      variables: RatingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<RatingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<RatingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<RatingsQuery, RatingsQueryVariables>(RatingsDocument)
    return useInfiniteQuery<RatingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ratings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteRatingsQuery.getKey = (variables: RatingsQueryVariables) => ['ratings.infinite', variables];

export const TopProductsStatsDocument = `
    query topProductsStats($saleId: String!, $optionKey: String) {
  topProductsStats(saleId: $saleId, optionKey: $optionKey) {
    available_option_keys
    current_option_key
    products {
      group_id
      image_url
      options
      product_name
      product_id
      purchased_count
      variants {
        image_url
        option_value
        options
        price
        product_id
        product_name
        purchased_count
        total_amount
        variant_id
      }
      total_amount
    }
  }
}
    `;

export const useTopProductsStatsQuery = <
      TData = TopProductsStatsQuery,
      TError = unknown
    >(
      variables: TopProductsStatsQueryVariables,
      options?: Omit<UseQueryOptions<TopProductsStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TopProductsStatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TopProductsStatsQuery, TError, TData>(
      {
    queryKey: ['topProductsStats', variables],
    queryFn: useFetchData<TopProductsStatsQuery, TopProductsStatsQueryVariables>(TopProductsStatsDocument).bind(null, variables),
    ...options
  }
    )};

useTopProductsStatsQuery.getKey = (variables: TopProductsStatsQueryVariables) => ['topProductsStats', variables];

export const useInfiniteTopProductsStatsQuery = <
      TData = InfiniteData<TopProductsStatsQuery>,
      TError = unknown
    >(
      variables: TopProductsStatsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TopProductsStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TopProductsStatsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<TopProductsStatsQuery, TopProductsStatsQueryVariables>(TopProductsStatsDocument)
    return useInfiniteQuery<TopProductsStatsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['topProductsStats.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteTopProductsStatsQuery.getKey = (variables: TopProductsStatsQueryVariables) => ['topProductsStats.infinite', variables];

export const StatsDocument = `
    query stats($saleId: NonEmptyString!) {
  statsV2(saleId: $saleId) {
    isSubjectToVat
    orderCount
    productSoldCount
    rateAvg
    rateCount
    rateCountAggByRates {
      rate
      count
    }
    totalBillingHt
    totalBillingTtc
    totalTurnoverHt
    totalTurnoverTtc
  }
}
    `;

export const useStatsQuery = <
      TData = StatsQuery,
      TError = unknown
    >(
      variables: StatsQueryVariables,
      options?: Omit<UseQueryOptions<StatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<StatsQuery, TError, TData>(
      {
    queryKey: ['stats', variables],
    queryFn: useFetchData<StatsQuery, StatsQueryVariables>(StatsDocument).bind(null, variables),
    ...options
  }
    )};

useStatsQuery.getKey = (variables: StatsQueryVariables) => ['stats', variables];

export const useInfiniteStatsQuery = <
      TData = InfiniteData<StatsQuery>,
      TError = unknown
    >(
      variables: StatsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<StatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<StatsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<StatsQuery, StatsQueryVariables>(StatsDocument)
    return useInfiniteQuery<StatsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['stats.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteStatsQuery.getKey = (variables: StatsQueryVariables) => ['stats.infinite', variables];

export const ReturnsDocument = `
    query returns($saleId: String!) {
  returns(saleId: $saleId) {
    percentage
    products {
      description
      image
      options
      sum
    }
    returns {
      sum
      code
      subCode
    }
    total_orders
    total_sum
    updatedAt
  }
}
    `;

export const useReturnsQuery = <
      TData = ReturnsQuery,
      TError = unknown
    >(
      variables: ReturnsQueryVariables,
      options?: Omit<UseQueryOptions<ReturnsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReturnsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReturnsQuery, TError, TData>(
      {
    queryKey: ['returns', variables],
    queryFn: useFetchData<ReturnsQuery, ReturnsQueryVariables>(ReturnsDocument).bind(null, variables),
    ...options
  }
    )};

useReturnsQuery.getKey = (variables: ReturnsQueryVariables) => ['returns', variables];

export const useInfiniteReturnsQuery = <
      TData = InfiniteData<ReturnsQuery>,
      TError = unknown
    >(
      variables: ReturnsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ReturnsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ReturnsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ReturnsQuery, ReturnsQueryVariables>(ReturnsDocument)
    return useInfiniteQuery<ReturnsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['returns.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteReturnsQuery.getKey = (variables: ReturnsQueryVariables) => ['returns.infinite', variables];

export const UploadUrlDocument = `
    query uploadUrl($fileName: String!, $fileType: String!) {
  getUploadUrl2(fileName: $fileName, fileType: $fileType) {
    url
    key
  }
}
    `;

export const useUploadUrlQuery = <
      TData = UploadUrlQuery,
      TError = unknown
    >(
      variables: UploadUrlQueryVariables,
      options?: Omit<UseQueryOptions<UploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UploadUrlQuery, TError, TData>(
      {
    queryKey: ['uploadUrl', variables],
    queryFn: useFetchData<UploadUrlQuery, UploadUrlQueryVariables>(UploadUrlDocument).bind(null, variables),
    ...options
  }
    )};

useUploadUrlQuery.getKey = (variables: UploadUrlQueryVariables) => ['uploadUrl', variables];

export const useInfiniteUploadUrlQuery = <
      TData = InfiniteData<UploadUrlQuery>,
      TError = unknown
    >(
      variables: UploadUrlQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<UploadUrlQuery, UploadUrlQueryVariables>(UploadUrlDocument)
    return useInfiniteQuery<UploadUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['uploadUrl.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteUploadUrlQuery.getKey = (variables: UploadUrlQueryVariables) => ['uploadUrl.infinite', variables];

export const VerifyShopifyCredentialsDocument = `
    query verifyShopifyCredentials($url: String!, $accessToken: String) {
  verifyShopifyCredentials(url: $url, accessToken: $accessToken) {
    isValidAccessToken
    isValidUrl
    error
  }
}
    `;

export const useVerifyShopifyCredentialsQuery = <
      TData = VerifyShopifyCredentialsQuery,
      TError = unknown
    >(
      variables: VerifyShopifyCredentialsQueryVariables,
      options?: Omit<UseQueryOptions<VerifyShopifyCredentialsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<VerifyShopifyCredentialsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<VerifyShopifyCredentialsQuery, TError, TData>(
      {
    queryKey: ['verifyShopifyCredentials', variables],
    queryFn: useFetchData<VerifyShopifyCredentialsQuery, VerifyShopifyCredentialsQueryVariables>(VerifyShopifyCredentialsDocument).bind(null, variables),
    ...options
  }
    )};

useVerifyShopifyCredentialsQuery.getKey = (variables: VerifyShopifyCredentialsQueryVariables) => ['verifyShopifyCredentials', variables];

export const useInfiniteVerifyShopifyCredentialsQuery = <
      TData = InfiniteData<VerifyShopifyCredentialsQuery>,
      TError = unknown
    >(
      variables: VerifyShopifyCredentialsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<VerifyShopifyCredentialsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<VerifyShopifyCredentialsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<VerifyShopifyCredentialsQuery, VerifyShopifyCredentialsQueryVariables>(VerifyShopifyCredentialsDocument)
    return useInfiniteQuery<VerifyShopifyCredentialsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['verifyShopifyCredentials.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteVerifyShopifyCredentialsQuery.getKey = (variables: VerifyShopifyCredentialsQueryVariables) => ['verifyShopifyCredentials.infinite', variables];

export const RemoveCsvDocument = `
    mutation removeCsv($saleId: String!, $url: String!) {
  removeCsv(saleId: $saleId, url: $url)
}
    `;

export const useRemoveCsvMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCsvMutation, TError, RemoveCsvMutationVariables, TContext>) => {
    
    return useMutation<RemoveCsvMutation, TError, RemoveCsvMutationVariables, TContext>(
      {
    mutationKey: ['removeCsv'],
    mutationFn: useFetchData<RemoveCsvMutation, RemoveCsvMutationVariables>(RemoveCsvDocument),
    ...options
  }
    )};

export const ConfirmCsvDocument = `
    mutation confirmCsv($saleId: String!, $url: String!) {
  confirmCsv(saleId: $saleId, url: $url)
}
    `;

export const useConfirmCsvMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ConfirmCsvMutation, TError, ConfirmCsvMutationVariables, TContext>) => {
    
    return useMutation<ConfirmCsvMutation, TError, ConfirmCsvMutationVariables, TContext>(
      {
    mutationKey: ['confirmCsv'],
    mutationFn: useFetchData<ConfirmCsvMutation, ConfirmCsvMutationVariables>(ConfirmCsvDocument),
    ...options
  }
    )};

export const UploadCsvFileDocument = `
    mutation uploadCsvFile($saleId: String!, $url: String!) {
  uploadCsvFile(saleId: $saleId, url: $url)
}
    `;

export const useUploadCsvFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UploadCsvFileMutation, TError, UploadCsvFileMutationVariables, TContext>) => {
    
    return useMutation<UploadCsvFileMutation, TError, UploadCsvFileMutationVariables, TContext>(
      {
    mutationKey: ['uploadCsvFile'],
    mutationFn: useFetchData<UploadCsvFileMutation, UploadCsvFileMutationVariables>(UploadCsvFileDocument),
    ...options
  }
    )};

export const UpdateWidgetDocument = `
    mutation updateWidget($id: String!, $data: UpdateWidget!) {
  updateWidget(id: $id, data: $data)
}
    `;

export const useUpdateWidgetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWidgetMutation, TError, UpdateWidgetMutationVariables, TContext>) => {
    
    return useMutation<UpdateWidgetMutation, TError, UpdateWidgetMutationVariables, TContext>(
      {
    mutationKey: ['updateWidget'],
    mutationFn: useFetchData<UpdateWidgetMutation, UpdateWidgetMutationVariables>(UpdateWidgetDocument),
    ...options
  }
    )};

export const UpdateSellerDocument = `
    mutation updateSeller($updateSeller: UpdateSeller!) {
  updateSeller(updateSeller: $updateSeller)
}
    `;

export const useUpdateSellerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSellerMutation, TError, UpdateSellerMutationVariables, TContext>) => {
    
    return useMutation<UpdateSellerMutation, TError, UpdateSellerMutationVariables, TContext>(
      {
    mutationKey: ['updateSeller'],
    mutationFn: useFetchData<UpdateSellerMutation, UpdateSellerMutationVariables>(UpdateSellerDocument),
    ...options
  }
    )};

export const SetInfoAsUpToDateDocument = `
    mutation setInfoAsUpToDate {
  setInfoAsUpToDate
}
    `;

export const useSetInfoAsUpToDateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetInfoAsUpToDateMutation, TError, SetInfoAsUpToDateMutationVariables, TContext>) => {
    
    return useMutation<SetInfoAsUpToDateMutation, TError, SetInfoAsUpToDateMutationVariables, TContext>(
      {
    mutationKey: ['setInfoAsUpToDate'],
    mutationFn: useFetchData<SetInfoAsUpToDateMutation, SetInfoAsUpToDateMutationVariables>(SetInfoAsUpToDateDocument),
    ...options
  }
    )};

export const TranslateClaimDocument = `
    mutation translateClaim($claimId: ID!, $to: String!) {
  translateClaim(claimId: $claimId, to: $to) {
    originalLanguage
    translation
  }
}
    `;

export const useTranslateClaimMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TranslateClaimMutation, TError, TranslateClaimMutationVariables, TContext>) => {
    
    return useMutation<TranslateClaimMutation, TError, TranslateClaimMutationVariables, TContext>(
      {
    mutationKey: ['translateClaim'],
    mutationFn: useFetchData<TranslateClaimMutation, TranslateClaimMutationVariables>(TranslateClaimDocument),
    ...options
  }
    )};

export const ResyncShopifyOrdersDocument = `
    mutation resyncShopifyOrders($saleId: String!) {
  resyncShopifyOrders(saleId: $saleId)
}
    `;

export const useResyncShopifyOrdersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResyncShopifyOrdersMutation, TError, ResyncShopifyOrdersMutationVariables, TContext>) => {
    
    return useMutation<ResyncShopifyOrdersMutation, TError, ResyncShopifyOrdersMutationVariables, TContext>(
      {
    mutationKey: ['resyncShopifyOrders'],
    mutationFn: useFetchData<ResyncShopifyOrdersMutation, ResyncShopifyOrdersMutationVariables>(ResyncShopifyOrdersDocument),
    ...options
  }
    )};

export const ResyncShopifyStockDocument = `
    mutation resyncShopifyStock($saleId: String!) {
  resyncShopifyStock(saleId: $saleId)
}
    `;

export const useResyncShopifyStockMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResyncShopifyStockMutation, TError, ResyncShopifyStockMutationVariables, TContext>) => {
    
    return useMutation<ResyncShopifyStockMutation, TError, ResyncShopifyStockMutationVariables, TContext>(
      {
    mutationKey: ['resyncShopifyStock'],
    mutationFn: useFetchData<ResyncShopifyStockMutation, ResyncShopifyStockMutationVariables>(ResyncShopifyStockDocument),
    ...options
  }
    )};

export const SetupShopifyCredentialsDocument = `
    mutation setupShopifyCredentials($brandId: String!, $data: ShopifyCredentialsInput!) {
  setupShopifyCredentials(brandId: $brandId, data: $data) {
    carrierCode
    internationalCarrierCode
    isProductPriceKept
    isStockLive
    mondialRelayCarrierCode
    logisticProvider
    sharedSecret
    shop
    token
    canSyncReturn
    enableReturnOrderCreation
    orderTag
    inventoryNames
    canReadLocations
    canWriteThirdPartyFulfillmentOrders
  }
}
    `;

export const useSetupShopifyCredentialsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetupShopifyCredentialsMutation, TError, SetupShopifyCredentialsMutationVariables, TContext>) => {
    
    return useMutation<SetupShopifyCredentialsMutation, TError, SetupShopifyCredentialsMutationVariables, TContext>(
      {
    mutationKey: ['setupShopifyCredentials'],
    mutationFn: useFetchData<SetupShopifyCredentialsMutation, SetupShopifyCredentialsMutationVariables>(SetupShopifyCredentialsDocument),
    ...options
  }
    )};

export const SubmitReviewsFeatureInterestDocument = `
    mutation submitReviewsFeatureInterest($isInterested: Boolean!) {
  submitReviewsFeatureInterest(isInterested: $isInterested)
}
    `;

export const useSubmitReviewsFeatureInterestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitReviewsFeatureInterestMutation, TError, SubmitReviewsFeatureInterestMutationVariables, TContext>) => {
    
    return useMutation<SubmitReviewsFeatureInterestMutation, TError, SubmitReviewsFeatureInterestMutationVariables, TContext>(
      {
    mutationKey: ['submitReviewsFeatureInterest'],
    mutationFn: useFetchData<SubmitReviewsFeatureInterestMutation, SubmitReviewsFeatureInterestMutationVariables>(SubmitReviewsFeatureInterestDocument),
    ...options
  }
    )};

export const UpdateShopifyInfoDocument = `
    mutation updateShopifyInfo($data: UpdateShopifyInfoInput!) {
  updateShopifyInfo(data: $data) {
    carrierCode
    internationalCarrierCode
    isProductPriceKept
    isStockLive
    mondialRelayCarrierCode
    logisticProvider
    canSyncReturn
    enableReturnOrderCreation
    orderTag
    inventoryNames
    canReadLocations
    canWriteThirdPartyFulfillmentOrders
  }
}
    `;

export const useUpdateShopifyInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateShopifyInfoMutation, TError, UpdateShopifyInfoMutationVariables, TContext>) => {
    
    return useMutation<UpdateShopifyInfoMutation, TError, UpdateShopifyInfoMutationVariables, TContext>(
      {
    mutationKey: ['updateShopifyInfo'],
    mutationFn: useFetchData<UpdateShopifyInfoMutation, UpdateShopifyInfoMutationVariables>(UpdateShopifyInfoDocument),
    ...options
  }
    )};

export const InvoiceCreatedDocument = `
    subscription invoiceCreated {
  invoiceCreated {
    id
  }
}
    `;
export const InvoiceUpdatedDocument = `
    subscription invoiceUpdated {
  invoiceUpdated {
    id
  }
}
    `;
export const OrderCreatedDocument = `
    subscription orderCreated {
  orderCreated {
    id
  }
}
    `;
export const OrderUpdatedDocument = `
    subscription orderUpdated {
  orderUpdated {
    id
  }
}
    `;
export const WidgetUpdatedDocument = `
    subscription widgetUpdated {
  widgetUpdated {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;